import { interfaces } from "inversify";
import { QueuesData } from "~/backend/generated/QueueStats/model/queuesData";
import { queueStatsQueuesProviderRTTI, QueueStatsQueuesProvider } from "~/modules/queueStats";

export const getQueueStatsQueues =
    (container: interfaces.Container) =>
    async (sessionToken: string, workspaceSid: string, queryParams?: string): Promise<QueuesData> => {
        const configProvider = container.get<QueueStatsQueuesProvider>(queueStatsQueuesProviderRTTI);
        const config = await configProvider(sessionToken, workspaceSid, queryParams);
        return config;
    };
